import { config } from "@fortawesome/fontawesome-svg-core";
import {
  faAlignJustify,
  faAnglesLeft,
  faAnglesRight,
  faArrowDown,
  faArrowRotateLeft,
  faArrowRotateRight,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowsRotate,
  faArrowsUpDownLeftRight,
  faCartShopping,
  faCheck,
  faChevronDown,
  faChevronRight,
  faChevronUp,
  faClipboard,
  faCircleInfo,
  faClone,
  faClock,
  faCode,
  faDotCircle,
  faEnvelope,
  faExclamationCircle,
  faFileAlt,
  faFileExport,
  faFilter,
  faGear,
  faGripVertical,
  faImage,
  faHandPointer,
  faLink,
  faMagnifyingGlass,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faMinus,
  faPen,
  faPlus,
  faQrcode,
  faQuestion,
  faRectangleList,
  faRefresh,
  faReceipt,
  faSave,
  faSquare,
  faSort,
  faTableColumns,
  faTag,
  faTicket,
  faTimes,
  faTrash,
  faUser,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

// Make sure this is before any other `fontawesome` API calls
config.autoAddCss = false;

export {
  faAlignJustify as TextIcon,
  faAnglesLeft as AnglesLeft,
  faAnglesRight as AnglesRight,
  faArrowDown as ArrowDown,
  faArrowLeft as ArrowLeft,
  faArrowRight as ArrowRight,
  faArrowUp as ArrowUp,
  faArrowsRotate as RotateIcon,
  faArrowRotateLeft as UndoIcon,
  faArrowRotateRight as RedoIcon,
  faArrowsUpDownLeftRight as MoveIcon,
  faCartShopping as CartIcon,
  faCheck as CheckIcon,
  faChevronDown as ChevronDown,
  faChevronRight as ChevronRight,
  faChevronUp as ChevronUp,
  faClipboard as ClipboardIcon,
  faCircleInfo as CircleInfo,
  faClone as CloneIcon,
  faClock as ClockIcon,
  faCode as CodeIcon,
  faDotCircle as DotCircleIcon,
  faEnvelope as EnvelopeIcon,
  faExclamationCircle as WarningIcon,
  faFileAlt as FileIcon,
  faFileExport as ExportIcon,
  faFilter as FilterIcon,
  faGear as SettingsIcon,
  faGripVertical as DragHandleIcon,
  faImage as ImageIcon,
  faHandPointer as HandIcon,
  faLink as LinkIcon,
  faMagnifyingGlass as MagnifyIcon,
  faMagnifyingGlassMinus as ZoomOutIcon,
  faMagnifyingGlassPlus as ZoomInIcon,
  faMinus as MinusIcon,
  faTableColumns as ColumnsIcon,
  faTag as RenameIcon,
  faTimes as TimesIcon,
  faTrash as DeleteIcon,
  faPen as EditIcon,
  faPlus as PlusIcon,
  faQrcode as QrcodeIcon,
  faQuestion as QuestionIcon,
  faRectangleList as RectangleListIcon,
  faRefresh as RefreshIcon,
  faReceipt as ReceiptIcon,
  faSave as SaveIcon,
  faSquare as SquareIcon,
  faSort as SortIcon,
  faTicket as TicketIcon,
  faUser as UserIcon,
  faXmark as CrossIcon,
};
